'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('ifeis.empty-state', []).directive('fEmptyState', function () {
  return {
    restrict: 'E',
    scope: {
      icon: '@'
    },
    transclude: true,
    template: require('./tpl.html')
  };
});


//////////////////
// WEBPACK FOOTER
// ./empty-state/index.js
// module id = 478
// module chunks = 0